import React from 'react'
import LazyLoad from 'react-lazyload'
import {SlotComponent} from '../../types/ui'
import {Recommender} from '../recommendations'
import {Stack} from '../../vanilla'
import {WelcomeBack} from '../welcome-back'
import {ProductCarouselType} from '../../types/cms'

export const ProductCarousel: SlotComponent<ProductCarouselType> = ({content}) => {
  
  if (!content) {
    return null
  }
  
  const {category, showFavourites, title, subtitle, einstein, cta} = content

  return showFavourites ? (
        <WelcomeBack 
        content={content}
        cta={cta} 
        title={title} 
        subtitle={subtitle}
        />
      ) : (
        <Stack>
          {einstein && (
            <LazyLoad once>
              <Recommender
                name={title}
                recommender={einstein?.recommenderId}
                categoryId={category?.id}
              />
            </LazyLoad>
          )}
        </Stack>
      )}
  
